export const getCredentialDisplayName = (credential, lang) => {
  const defaultLanguage = 'en'; // todo: use a more reliable default language
  const metaData = credential.metadata.find(meta => meta.language === lang) || credential.metadata.find(meta => meta.language === defaultLanguage);
  return metaData ? metaData.title : '';
};